<template>
    <div class="skeleton-wrapper">
      <!-- Картинка -->
      <div class="skeleton skeleton-image shimmer"></div>
  
      <div class="skeleton-content">
        <!-- Заголовок -->
        <div class="skeleton skeleton-title shimmer"></div>
  
        <!-- Регион -->
        <div class="skeleton skeleton-tag shimmer"></div>
  
        <!-- Описание (несколько строк) -->
        <div class="skeleton skeleton-line shimmer"></div>
        <div class="skeleton skeleton-line shimmer"></div>
        <div class="skeleton skeleton-line short shimmer"></div>
  
        <!-- Аватарки -->
        <div class="skeleton-avatars">
          <div v-for="n in 3" :key="n" class="skeleton skeleton-avatar shimmer"></div>
        </div>
  
        <!-- Кнопка -->
        <div class="skeleton skeleton-button shimmer"></div>
      </div>
    </div>
  </template>
  
  <style scoped>
  .skeleton-wrapper {
    width: 740px;
    margin: 0 auto;
    padding: 0;
  }
  
  /* Основные блоки */
  .skeleton {
    background: #e2e2e2;
    border-radius: 8px;
    margin-bottom: 16px;
    position: relative;
    overflow: hidden;
  }
  
  [data-theme="dark"] .skeleton {
    background: #2b2b2b;
  }
  
  /* SHIMMER */
  .shimmer::after {
    content: "";
    position: absolute;
    top: 0;
    left: -150px;
    height: 100%;
    width: 150px;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
    animation: shimmer 1.2s infinite;
  }
  
  @keyframes shimmer {
    0% { left: -150px; }
    100% { left: 100%; }
  }
  
  /* Sizes */
  .skeleton-image {
    height: 360px;
    width: 100%;
    border-radius: 16px;
  }
  
  .skeleton-content {
    padding: 20px;
  }
  
  .skeleton-title {
    height: 28px;
    width: 70%;
  }
  
  .skeleton-tag {
    height: 20px;
    width: 120px;
    border-radius: 20px;
    margin-top: 12px;
  }
  
  .skeleton-line {
    height: 16px;
    width: 100%;
  }
  
  .skeleton-line.short {
    width: 60%;
  }
  
  .skeleton-avatars {
    display: flex;
    gap: 12px;
    margin-top: 20px;
  }
  
  .skeleton-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  
  .skeleton-button {
    margin-top: 30px;
    width: 100%;
    height: 48px;
    border-radius: 12px;
  }
  </style>